import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { listPaginationLoaderDeps } from '../../list/pagination/list-pagination-loader-deps.ts';
import type { processDefinitionsArchivedQuery } from '../../process-definitions-archived/__generated__/processDefinitionsArchivedQuery.graphql.ts';
import relayReq from '../../process-definitions-archived/__generated__/processDefinitionsArchivedQuery.graphql.ts';
import type { processDefinitionsArchivedQueryFragment$data } from '../../process-definitions-archived/__generated__/processDefinitionsArchivedQueryFragment.graphql.ts';
import { ProcessDefinitionsArchived } from '../../process-definitions-archived/process-definitions-archived.tsx';
import { processDefinitionsArchivedSearchSchema } from '../../process-definitions-archived/process-definitions-archived-search-schema.ts';
import { relayEnv } from '../../relay/relay-env.ts';

type TProcessDefinitionArchivedKeys =
    keyof processDefinitionsArchivedQueryFragment$data['content'][number];

export const Route = createFileRoute('/_index/process-definitions-archived')({
    component: ProcessDefinitionsArchived,
    // errorComponent: () => <div>err</div>,
    loaderDeps: ({ search: { pageNum, pageSize, search, sortBy, sortDir } }) => ({
        ...listPaginationLoaderDeps(pageNum, pageSize),
        search,
        sortBy,
        sortDir,
    }),
    loader: (ctx) => {
        const searchBy: TProcessDefinitionArchivedKeys[] = [
            'id',
            'definitionKey',
            'definitionName',
            'definitionVersion',
        ];
        return loadQuery<processDefinitionsArchivedQuery>(
            relayEnv,
            relayReq,
            {
                ...ctx.deps,
                searchBy,
                filter: { siteUrl: { eq: ctx.context.site?.siteUrl }, status: { eq: 'ARCHIVED' } },
            },
            { fetchPolicy: 'store-and-network' }
        );
    },
    validateSearch: processDefinitionsArchivedSearchSchema,
});
